import React from 'react';

import { testId } from 'ui-components/services/testid-service';

/**
 * @typedef {import('./semi-circle-bar-types.d.ts').SemiCircleBarComponent} SemiCircleBarComponent
 */

/**
 * @type {SemiCircleBarComponent}
 */
export const SemiCircleBar = React.memo(({ diameter = 200, barWidth = 10, percentage = 0, startingAngle = 180, className = '' }) => {
  const outerRadius = diameter / 2;
  const innerRadius = diameter / 2 - barWidth;
  const innerCircumference = Math.PI * innerRadius;
  const strokeUnits = (percentage / 100) * innerCircumference;
  const remainingUnits = innerCircumference - strokeUnits;

  return (
    <React.Fragment>
      <circle
        className={className}
        cx={outerRadius}
        cy={outerRadius}
        fill='transparent'
        r={innerRadius}
        strokeDasharray={`${strokeUnits} ${remainingUnits}`}
        strokeDashoffset={(startingAngle / 180) * innerCircumference}
        strokeWidth={barWidth}
        {...testId('semi-circle-bar')}
      />
    </React.Fragment>
  );
});
